module.exports = __webpack_public_path__ + "static/media/Processed.d1f64c5e.svg";